<template>
  <b-container class="details mb-2">
    <b-row class="mb-1 tabHeader">
      <b-col cols="12" class="font-weight-bold" v-t="'productDetails.tabHeader.riskProfile'"></b-col>
    </b-row>
    <template v-if="isMop && showDistribution()">
      <b-row no-gutters>
        <b-col cols="12" class="text-center m-2" v-t="'productDetails.sriDistribution'"></b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12">
          <highcharts :key="hcKey" :options="chartOptions" ref="barChart"></highcharts>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <indicator-boxes v-model="sriValues" :max-value="7" class="legend" />
    </template>
  </b-container>
</template>
<script>
import { setChartMenuItemsLang } from '../../utils/formatter'
import IndicatorBoxes from './IndicatorBoxes'

export default {
  name: 'sri-chart',
  components: {
    IndicatorBoxes,
  },
  props: {
    value: {},
  },
  data() {
    return {
      hcKey: 0,
      sliderKey: 1,
    }
  },
  computed: {
    product: function () {
      return this.value
    },
    isMop: function () {
      return this.product.structure === 2
    },
    chartOptions: function () {
      return {
        lang: this.setOptions,
        chart: {
          type: 'column',
          backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primaryBGColor'),
          height: '235px',
        },
        legend: {
          enabled: false,
        },
        colors: [getComputedStyle(document.documentElement).getPropertyValue('--secondary')],
        tooltip: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: [1, 2, 3, 4, 5, 6, 7],
          title: {
            text: null,
          },
          labels: {
            formatter: this.formatChartLabel,
            useHTML: true,
            rotation: 0,
          },
        },
        yAxis: {
          gridLineWidth: 0,
          title: {
            text: null,
          },
          labels: {
            enabled: false,
          },
          min: 0,
        },
        plotOptions: {
          column: {
            pointPadding: 0,
            borderWidth: 0,
          },
        },
        series: [
          {
            data: this.product.sriDistribution != null ? Object.values(this.product.sriDistribution) : [],
            dataLabels: {
              enabled: true,
              crop: false,
              overflow: 'none',
            },
          },
        ],
      }
    },
    sriValues: {
      get: function () {
        return {
          min: this.product.sriMin,
          max: this.product.sriMax,
        }
      },
      set: function (newValue) {
        this.product.sriMin = newValue.min
        this.product.sriMax = newValue.max
      },
    },
    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
  methods: {
    showDistribution() {
      return Object.keys(this.product.sriDistribution)
        .map((key) => this.product.sriDistribution[key])
        .some((el) => el > 0)
    },
    formatChartLabel(val) {
      if (!this.product) return ''
      return (
        '<div class="' +
        (val.value < this.product.sriMin || val.value > this.product.sriMax ? 'inactive' : 'active') +
        '">' +
        val.value +
        '</div>'
      )
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .inactive,
/deep/ .active {
  color: white;
  height: 55px;
  width: 55px;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}

/deep/ .inactive {
  background-color: transparent;
  color: black;
  border: 1px solid #3bdaff;
}

/deep/ .active {
  background-color: #00a6e3;
  color: white;
}

/deep/ .editedLegend .active {
  background-color: #e34d15;
}
</style>
